import { register } from "@shopify/theme-sections";
import $ from "jquery";
const EMAIL_REGEXP =
	/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
const selectors = {
	klavioJs: ".klavioJs",
	statusJsSuc: ".js-account-edit-status",
	statusJsErr: ".js-account-edit-status2",
	isPdpRead: "#isPdpRead",
	email: "#pdpEmailInput"
};
register("pdp-newsletter", {
	onLoad: function () {
		this.initKlaviyo();
	},
	initKlaviyo() {
		const statusJsSuc = $(selectors.statusJsSuc);
		const statusJsErr = $(selectors.statusJsErr);
		this.isPdpRead = this.container.querySelector(selectors.isPdpRead);
		this.email = this.container.querySelector(selectors.email);
		this.publicTokenClaviyo = window.klaviyoPublicKey.key;
		this.listId = $(selectors.email).attr("data-token");

		const klaviyoSend = (e) => {
			e.preventDefault();
			let settings = {
				async: true,
				crossDomain: true,
				url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
				method: "POST",
				headers: {
					"content-type": "application/x-www-form-urlencoded",
					"cache-control": "no-cache"
				},
				data: {
					g: `${this.listId}`,
					email: `${this.email.value}`
				}
			};
			if (
				this.isPdpRead.checked &&
				this.validateEmail(this.email.value)
			) {
				$.ajax(settings).done(function (response) {
					if (response.success && !response.data.is_subscribed) {
						if (statusJsSuc) {
							statusJsSuc.removeClass("hide");
						}
						if (statusJsErr) {
							statusJsErr.addClass("hide");
						}
					} else {
						if (statusJsErr) {
							statusJsErr.removeClass("hide");
						}
						if (statusJsSuc) {
							statusJsSuc.addClass("hide");
						}
					}
				});
			} else {
				if (!this.isPdpRead.checked) {
					this.isPdpRead.classList.add("error");
				}
				if (!this.validateEmail(this.email.value)) {
					statusJsErr.removeClass("hide");
				}
			}
		};
		this.container
			.querySelector(selectors.klavioJs)
			.addEventListener("click", klaviyoSend);
	},
	validateEmail(value) {
		return EMAIL_REGEXP.test(value);
	}
});
